"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = networkChange;
var handlers = {};
function checkConnectivity() {
  /**
  * PWA Starter Demo
  * Add logic to change colors or theme here to let user know about connectivity changes
  */
  if (navigator.onLine) {
    navigator.serviceWorker.ready.then(function (reg) {
      if (handlers.onlineHandler) {
        return handlers.onlineHandler({
          reg: reg
        });
      }
      return null;
    });
  } else {
    navigator.serviceWorker.ready.then(function (reg) {
      if (handlers.offlineHandler) {
        return handlers.offlineHandler({
          reg: reg
        });
      }
      return null;
    });
  }
}
function addListeners() {
  removeListeners();
  window.addEventListener("online", checkConnectivity, false);
  window.addEventListener("offline", checkConnectivity, false);
}
function removeListeners() {
  window.removeEventListener("online", checkConnectivity, false);
  window.removeEventListener("offline", checkConnectivity, false);
}
function networkChange() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var wapp = p.wapp,
    onlineHandler = p.onlineHandler,
    offlineHandler = p.offlineHandler;
  handlers.onlineHandler = onlineHandler;
  handlers.offlineHandler = offlineHandler;
  if (wapp.pwa.addedCheckConnectivityListener) {
    window.removeEventListener("online", wapp.pwa.addedCheckConnectivityListener, false);
    window.removeEventListener("offline", wapp.pwa.addedCheckConnectivityListener, false);
  }
  wapp.pwa.addedCheckConnectivityListener = checkConnectivity;
  addListeners();
  if (!navigator.onLine) {
    checkConnectivity();
  }
}